<template>
  <base-container :fluid="true" class="pf-table-view">
    <base-container>
      <the-header>
        <template v-slot:leftAligned>
          <h1 class="lvl1-heading">
            Liste de
            <span>Fiches vidéos</span>
          </h1>
        </template>
      </the-header>
    </base-container>
    <div class="pf-table-view__main">
      <base-container :fluid="true" class="pf-table-view__filters">
        <el-input
          placeholder="Recherche produits, marques"
          v-model="filters.keyword"
          class="pf-table-view__filter-item pf-table-view__keyword-input"
          @keyup.enter.native="getVideos"
        ></el-input>
        <base-button
          @click.native="getVideos"
          class="pf-table-view__filter-item pf-table-view__search-button"
          :fluid="false"
          >Recherche</base-button
        >
      </base-container>
      <base-container :fluid="true" class="pf-table-view__table">
        <el-table
          ref="table"
          :data="videos"
          :default-sort="{ prop: 'created_at', order: 'descending' }"
          style="width: 100%"
          border
          fit
          highlight-current-row
          empty-text="Aucune vidéo trouvée"
          :row-class-name="tableRowVod"
          @sort-change="sortVideos($event)"
        >
          <el-table-column
            align="center"
            prop="id"
            label="id"
            width="80"
            sortable
          ></el-table-column>
          <el-table-column
            align="center"
            prop="title"
            label="Titre"
            min-width="160"
            sortable
          ></el-table-column>
          <el-table-column
            align="center"
            prop="brand.name"
            label="Marque"
            min-width="160"
            sortable
          ></el-table-column>
          <el-table-column
            align="center"
            prop="theme.name"
            label="Thématique"
            min-width="160"
            sortable
          ></el-table-column>
          <!-- <el-table-column
            align="center"
            prop="support.name"
            label="Support"
            min-width="160"
            sortable
          ></el-table-column> -->
          <el-table-column
            align="center"
            prop="type_supports"
            label="Types de supports compatibles"
            min-width="120"
          >
            <template slot-scope="{ row }">
              <base-tag
                v-for="(type, index) in row.type_supports"
                :key="index"
                :label="type.name"
              />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="nb_diffusions"
            label="Diffusion(s)"
            min-width="120"
            sortable
          ></el-table-column>
          <el-table-column
            align="center"
            label="Actions"
            width="140"
            class-name
          >
            <template slot-scope="{ row }">
              <el-button
                @click="handleTableItemEdit(row)"
                class="action-buttton action-buttton--edit"
                type="primary"
                icon="el-icon-edit"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </base-container>
      <base-container
        :fluid="true"
        :centered="true"
        class="pf-table-view__pagination"
      >
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalVideos"
          :current-page.sync="filters.page"
          :page-size="videosPerPage"
          @current-change="getVideos"
        ></el-pagination>
      </base-container>
    </div>
  </base-container>
</template>

<script>
import { Pagination, Button, Input, Table, TableColumn } from "element-ui"
import TheHeader from "@/components/TheHeader"
import { getVideos as fetchVideos } from "@/api/videos"
import { emitter } from "@/utils"
import { loaderMixin } from "@/mixins"
export default {
  components: {
    TheHeader,
    ElInput: Input,
    ElButton: Button,
    ElPagination: Pagination,
    ElTable: Table,
    ElTableColumn: TableColumn
  },
  mixins: [loaderMixin],
  data() {
    return {
      videos: [],
      filters: {
        keyword: "",
        page: 1,
        sortField: null,
        sortDirection: null
      },
      videosPerPage: 0,
      totalVideos: 0
    }
  },
  methods: {
    getVideos() {
      this.openLoader(this.loadingTarget)

      fetchVideos(this.filters)
        .then(res => {
          this.videos = res.data.map(v => {
            const _date = new Date(v.created_at)
            const d = _date.toISOString().slice(0, 10)
            const h = _date.getHours()
            const min = _date.getMinutes()
            const date_string = `${d} à ${h}:${min}`
            return Object.assign(v, {
              date_string
            })
          })
          this.currentPage = res.current_page
          this.videosPerPage = res.per_page
          this.totalVideos = res.total
          this.closeLoader()
        })
        .catch(() => {
          this.closeLoader()
        })
    },
    handleTableItemEdit(item) {
      this.$store.dispatch("openModal", {
        name: "video-edit-form",
        payload: { video: item, videos: this.videos }
      })
    },
    tableRowVod({ row }) {
      return row.vod ? "request" : ""
    },
    sortVideos(params) {
      console.log(params)
      if (params.order) {
        const sortOrder = params.order[0] === "d" ? "desc" : "asc"
        this.filters.sortField = params.prop
        this.filters.sortDirection = sortOrder
      }
      this.getVideos()
    }
  },
  mounted() {
    this.loadingTarget = this.$refs.table.$el.querySelector(
      ".el-table__body-wrapper"
    )
    this.getVideos()

    emitter.$on("freelancer-video-added", () => {
      this.getVideos()
    })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" src="@/styles/table.scss"></style>

<style lang="scss">
.el-table__row.request {
  background: rgb(255, 230, 201);
  &.current-row > td {
    background: rgba(255, 209, 166, 0.705);
  }
}
.el-table__body tr.request:hover > td {
  background: rgba(255, 178, 106, 0.747);
}
</style>
